import type { FC } from 'react'
import type { TickFilter } from '@g4g/utils/src/types'
import Image from 'next/image'
import { DealFiltersTickTrait } from '../../provider/types'
import { classNames } from '@g4g/utils/src/react/class-names'
import FilterFeedbackClose from './FilterFeedbackClose'

const FilterFeedback: FC<{ filter?: TickFilter; trait: DealFiltersTickTrait }> = ({
  filter,
  trait,
}) => (
  <>
    {filter && (
      <div data-cy="shop-filter-feedback" data-cy-spec={filter.id} className="mb-2 mr-3">
        <div
          className={classNames(
            'flex items-center py-1 pl-3 pr-2 space-x-2',
            'rounded text-white/90 bg-white/10'
          )}
        >
          <div className="flex items-center space-x-1">
            {filter.iconPath && (
              <div className="w-5 h-5">
                <Image src={filter.iconPath} height={20} width={20} alt={filter.name} />
              </div>
            )}
            <p className="text-white/90 text-md">{filter.name}</p>
          </div>
          <FilterFeedbackClose trait={trait} id={filter.id} />
        </div>
      </div>
    )}
  </>
)

export default FilterFeedback
